/* eslint-disable import/no-anonymous-default-export */
export default [
    {
      name : '',
      type: 'Select'
    },
    {
      name: 'House Rent Allowance',
      type: 'House Rent Allowance'
    },
    {
      name: 'Fixed Allowance',
      type: 'Fixed Allowance'
    },
    {
      name: 'Conveyence Allowance',
      type: 'Conveyence Allowance'
    },
    {
      name: 'Transport Allowance',
      type: 'Transport Allowance'
    },
    {
      name: 'Travelling Allowance',
      type: 'Travelling Allowance'
    },
    {
      name: 'Children Education Allowance',
      type: 'Children Education Allowance'
    },
    {
      name: 'Bonus',
      type: 'Bonus'
    },
    {
      name: 'Commission',
      type: 'Commission'
    },
    {
      name: 'Leave Encashment',
      type: 'Leave Encashment'
    },
    {
      name: 'Gratutity',
      type: 'Gratutity'
    },
    {
      name: 'Notice Pay',
      type: 'Notice Pay'
    },
    {
      name : '',
      type: 'Other'
    }

  ];